module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_retail-cca9622dc82b1acf5b349fe7a1350d8b.png";